import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useModeOfTransports = defineStore('mode-of-transports', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.modeOfTransport_List,
    dto: 'ModeOfTransportDto',
    create: api.modeOfTransport_Create,
    update: api.modeOfTransport_Update,
    delete: api.modeOfTransport_Delete,
    usage: api.modeOfTransport_GetModeOfTransportUsage,
    signalR: 'ModeOfTransportUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
